module.exports = __webpack_public_path__ + "img/c.6c4eebdd.jpg";